import {type Operation} from 'apollo-link';

/**
 * Reads the backend (gorilla) trace id from the X-Wandb-Trace-Id response
 * header: first off a non-2xx networkError's response, then off the operation
 * context. Returns undefined when absent — Headers.get yields null on a missing
 * header, so we coalesce to a clean string | undefined.
 */
export function getWandbTraceId(
  networkError: unknown,
  operation: Operation
): string | undefined {
  return (
    (networkError as any)?.response?.headers?.get?.('x-wandb-trace-id') ??
    operation.getContext().response?.headers?.get?.('x-wandb-trace-id') ??
    undefined
  );
}
